










































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import USD from "@/components/USD.vue";
import BaseMenu from "./components/BaseMenu.vue";
import SlotModal from "./components/SlotModal.vue";
import Scroller from "@/components/Scroll.vue";

import {
  MerchCategoryDto,
  MerchFoodForBusinessDto,
  MerchFoodStatus,
  MerchFoodOutOfStock,
  TabIndex
} from "../../types/interface/Food/foodTypes";
import {
  getCategoriesByMerchId,
  getFoodsByCategory,
  scheduleAdd
} from "../../api/net/food";
import { yamimealLogo } from "../../config/general";
import {
  changeFoodStatus,
  changeStock,
  categoryList,
  findFoodsByCategoryId
} from "../../api/php/food";
import store from "../../store/index";
@Component({
  components: {
    USD,
    BaseMenu,
    SlotModal,
    Scroller
  }
})
export default class Menu extends BaseMenu {
  tabIndex: number = 0;
  tabs: Array<{ [key: string]: string | number }> = [
    "All",
    "Out of Stock",
    "Unavailable",
    "Sales"
  ].map((x, index) => {
    return {
      id: Math.random()
        .toString(36)
        .substring(2),
      text: x,
      count: 0
    };
  });
  categoryIndex: number = 0;
  categoryTabs: Array<{ id: string; name: string }> = [];
  baseFoods: MerchFoodForBusinessDto[] = [];
  foods: MerchFoodForBusinessDto[] = [];
  defaultFoods: MerchFoodForBusinessDto[] = [];
  listHeight: number = 1000;
  searchInput: string = "";
  timeout: any;
  @Getter("merchId") merchId!: string;
  @Watch("tabIndex")
  onTabIndexChange(newIndex: number) {
    this.filterFoodsByTabIndex(newIndex, this.baseFoods);
  }

  @Watch("categoryId")
  onCategoryIndexChange(categoryId: string) {
    this.getFoodsByCategoryId(categoryId);
  }

  miniBanner(banner: string): string {
    return banner ? `${banner}?imageView2/2/w/100` : yamimealLogo;
  }

  filterFoodsByTabIndex(
    index: number,
    foods: MerchFoodForBusinessDto[]
  ): number {
    switch (index) {
      case TabIndex.All:
        this.foods = foods;
        break;
      case TabIndex.OutOfStock:
        this.foods = foods.filter(
          x => x.stock === MerchFoodOutOfStock.OutOfStock
        );
        break;
      case TabIndex.Unavailable:
        this.foods = foods.filter(x => x.status === MerchFoodStatus.OffSale);
        break;
      case TabIndex.Sales:
        this.foods = foods.filter(
          x =>
            x.stock !== MerchFoodOutOfStock.OutOfStock &&
            x.status !== MerchFoodStatus.OffSale
        );
        break;
    }
    this.defaultFoods = this.foods;
    this.searchInput = "";
    return this.foods.length;
  }

  async activeFood(foodId: string) {
    const { code, data, msg } = await changeFoodStatus(foodId);
    if (code * 1 === 0) {
      this.getFoodsByCategoryId(this.categoryId);
      this.$message.show({
        text: "Success"
      });
    } else {
      this.$message.show({
        text: msg
      });
    }
    store.commit("handleShowLoading", false);
  }

  public get categoryId(): string {
    return this.categoryTabs.length
      ? this.categoryTabs[this.categoryIndex].id
      : "";
  }

  async initCategories() {
    const { code, data } = await categoryList();
    if (code * 1 === 0) {
      this.categoryTabs = data.map((x: MerchCategoryDto) => {
        let { id, name } = x;
        return { id, name };
      });
    }
    store.commit("handleShowLoading", false);
  }

  async getFoodsByCategoryId(categoryId: string) {
    if (!categoryId) {
      return;
    }
    const {
      code,
      data: { list }
    } = await findFoodsByCategoryId(categoryId);
    if (code * 1 === 0) {
      this.baseFoods = list;
      this.tabs = this.tabs.map((x, index) => {
        return Object.assign(x, {
          count: this.filterFoodsByTabIndex(index, this.baseFoods)
        });
      });
      try {
        this.baseFoods.sort((a, b) => {
          return b.name > a.name ? -1 : 1;
        });
        this.baseFoods.sort((a, b) => {
          return b.status - a.status;
        });
      } catch (error) {
        return;
      }
      this.filterFoodsByTabIndex(this.tabIndex, this.baseFoods);
    }
    store.commit("handleShowLoading", false);
  }

  loading: boolean = false;

  // 修改库存
  async submitStockModal() {
    if (
      (typeof this.rules.required(this.stock)).toLocaleLowerCase() ===
        "boolean" &&
      (typeof this.rules.counter(this.stock)).toLocaleLowerCase() === "boolean"
    ) {
      try {
        this.loading = true;
        let {
          data: { code, data, msg }
        } = await changeStock(this.currentItem.id, this.stock);
        this.loading = false;
        if (code * 1 === 0) {
          this.showStockModal = false;
          this.getFoodsByCategoryId(this.categoryId);
        } else {
          this.$message.show({
            text: msg
          });
        }
      } catch (error) {
        this.loading = false;
      }
      store.commit("handleShowLoading", false);
    }
  }

  // 马上上下架
  async foodUnactive() {
    let result = await this.$modal.open({
      title: "Are you sure to choose?",
      message: ""
    });

    try {
      if (result) {
        this.showItemActiveModal = false;
        const { code, data, msg } = await changeFoodStatus(this.currentItem.id);
        this.showItemActiveModal = false;
        if (code * 1 === 0) {
          this.getFoodsByCategoryId(this.categoryId);
        } else {
          this.$message.show({
            text: msg
          });
        }
      }
    } catch (error) {
      this.showItemActiveModal = false;
    }
    store.commit("handleShowLoading", false);
  }

  // 定时上下架
  async actionUntilSpecificTimeModal() {
    this.showUntilSpecificTimeModal = false;
    if (!this.dateTime || !this.currentItem.id) {
      this.$message.show({
        text: "Time can not be empty"
      });
      return;
    }

    await changeFoodStatus(this.currentItem.id),
      await scheduleAdd({
        foodId: this.currentItem.id,
        expirationTime: this.dateTime
      });
    await this.getFoodsByCategoryId(this.categoryId);
    this.closeUntilSpecificTimeModal();
    store.commit("handleShowLoading", false);
  }

  debounce(callback: Function, wait: number) {
    return (() => {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        callback();
      }, wait);
    })();
  }

  searchFood() {
    this.debounce(() => {
      this.foods = this.defaultFoods.filter(
        item =>
          item.name.toUpperCase().indexOf(this.searchInput.toUpperCase()) != -1
      );
      if (this.searchInput === "") {
        this.foods = this.defaultFoods;
      }
    }, 300);
  }

  async mounted() {
    await this.initCategories();
    this.listHeight = document.body.offsetHeight - 285;
  }
}
